import { AuthRoles } from '@hefe/auth';
import CoachConflictsPage from '../containers/admin/pages/coach-conflicts/coach-conflicts.page';
import AdminMessagesPages from '../containers/admin/pages/messages/admin-messages.page';
import TeamsPage from '../containers/admin/pages/teams/teams.page';
import CarsReservationsPage from '../containers/cars/pages/cars-reservations/cars-reservations.page';
import CarsPage from '../containers/cars/pages/cars/cars.page';
import ClubPage from '../containers/club/pages/club/club.page';
import CoaachLoggingPage from '../containers/coach-logging/pages/coach-logging/coach-logging.page';
import Dashboard from '../containers/dashboard/views/dashboard/dashboard';
import ClubEventsPage from '../containers/events/pages/club-events/club-events.page';
import UserEventsPage from '../containers/events/views/user-events-page/user-events.page';
import GamedayPlanerPage from '../containers/gameday-planer/pages/gameday-planer/gameday-planer.page';
import GymClosuresPage from '../containers/gyms/pages/gym-closures/gym-closures.page';
import GymsPage from '../containers/gyms/pages/gyms.page';
import InventoryPage from '../containers/inventory/pages/inventory/inventory.page';
import UserInventoriesPage from '../containers/inventory/pages/user-inventories/user-inventories.page';
import AddEditKnowledgeBaseArticlePage from '../containers/knowledge-base/pages/add-edit-knowledge-base-article/add-edit-knowledge-base-article.page';
import KnowledgeBaseArticlePage from '../containers/knowledge-base/pages/knowledge-base-article/knowledge-base-article.page';
import KnowledgeBaseCategoryPage from '../containers/knowledge-base/pages/knowledge-base-category/knowledge-base-category.page';
import KnowledgeBaseHomePage from '../containers/knowledge-base/pages/knowledge-base-home/knowledge-base-home.page';
import KnowledgeBaseSearchResultsPage from '../containers/knowledge-base/pages/knowledge-base-search-results/knowledge-base-search-results.page';
import LeaguesPage from '../containers/leagues/pages/leagues.page';
import UserMessagesPage from '../containers/messages/pages/user-messages/user-messages.page';
import OperationsCenterPage from '../containers/operations-center/pages/operations-center/operations-center.page';
import PartnersPage from '../containers/partners/pages/partners/partners.page';
import PracticeTimesPage from '../containers/practices/pages/practice-times/practice-times.page';
import PracticesAdminPage from '../containers/practices/pages/practices-admin/practices-admin.page';
import SchedulePage from '../containers/schedule/pages/schedule/schedule.page';
import SeasonPlanerPage from '../containers/season-planer/pages/season-planer/season-planer.page';
import StatisticsPage from '../containers/statistics/pages/statistics/statistics.page';
import SwitchRequestsPage from '../containers/switch-requests/pages/switch-requests/switch-requests.page';
import VersionsPage from '../containers/system/pages/versions/versions.page';
import ClubTasksPage from '../containers/tasks/pages/club-tasks/club-tasks.page';
import TeamTasksPage from '../containers/tasks/pages/team-tasks/team-tasks.page';
import UserTasksPage from '../containers/tasks/user-tasks/user-tasks.page';
import TeamEventsPage from '../containers/team/pages/team-events/team-events.page';
import TeamJerseysPage from '../containers/team/pages/team-jerseys/team-jerseys.page';
import TeamJudgesPage from '../containers/team/pages/team-judges/team-judges.page';
import TeamMessagesPage from '../containers/team/pages/team-messages/team-messages.page';
import TeamPlayersPage from '../containers/team/pages/team-players/team-players.page';
import TeamSettingsPage from '../containers/team/pages/team-settings/team-settings.page';
import UserProfilePage from '../containers/user/pages/user-profile/user-profile.page';
import UserSettingsPage from '../containers/user/pages/user-settings/user-settings.page';
import InvitationLinksPage from '../containers/users/pages/invitation-links/invitation-links.page';
import UsersPage from '../containers/users/pages/users/users.page';
import { ForgotPasswordPage } from '../views/base/forgot-password/forgot-password.page';
import { LoginPage } from '../views/base/login/login.page';
import RegisterPage from '../views/base/register/register.page';
import { ResetPasswordPage } from '../views/base/reset-password/reset-password.page';
import WelcomePage from '../views/base/welcome/welcome.page';

interface Route {
  path: string;
  pathIncludes?: string;
  name: string;
  auth: string[];
  component: any;
}

/*
const Calendar = Loadable({
  loader: () => import('./main/views/base/organization/calendar'),
  loading: Loading,
});

const Cars = Loadable({
  loader: () => import('./main/views/base/basedata/inventory/cars'),
  loading: Loading,
});

const Contacts = Loadable({
  loader: () => import('./main/views/base/basedata/contacts'),
  loading: Loading,
});

const Club = Loadable({
  loader: () => import('./main/views/base/basedata/club'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./main/views/base/dashboard'),
  loading: Loading,
});

const FeeCategories = Loadable({
  loader: () => import('./main/views/base/basedata/feecategories'),
  loading: Loading,
});

const ForgotPassword = Loadable({
  loader: () => import('./main/views/base/general/forgotpassword'),
  loading: Loading,
});

const Gyms = Loadable({
  loader: () => import('./main/views/base/basedata/inventory/gyms'),
  loading: Loading,
});

const Inventory = Loadable({
  loader: () => import('./main/views/base/basedata/inventory/general'),
  loading: Loading,
});

const Login = Loadable({
  loader: () => import('./main/views/base/general/login'),
  loading: Loading,
});

const Managers = Loadable({
  loader: () => import('./main/views/base/basedata/managers'),
  loading: Loading,
});

const Members = Loadable({
  loader: () => import('./main/views/base/basedata/members'),
  loading: Loading,
});

const Messages = Loadable({
  loader: () => import('./main/views/base/organization/messages'),
  loading: Loading,
});

const Registration = Loadable({
  loader: () => import('./main/views/base/general/register'),
  loading: Loading,
});

const ResetPassword = Loadable({
  loader: () => import('./main/views/base/general/resetpassword'),
  loading: Loading,
});

const Tasks = Loadable({
  loader: () => import('./main/views/base/organization/tasks'),
  loading: Loading,
});

const WelcomePage = Loadable({
  loader: () => import('./main/views/base/general/welcome/WelcomePage.js'),
  loading: Loading,
});

/*
 *      BASKETBALL MODULE
 */

/*
const BBArchive = Loadable({
  loader: () => import('./main/views/basketball/season/archive'),
  loading: Loading,
});

const BBChangelog = Loadable({
  loader: () => import('./main/views/basketball/general/changelog'),
  loading: Loading,
});

const BBAdminAwayGames = Loadable({
  loader: () => import('./main/views/basketball/admin/season/awaygames'),
  loading: Loading,
});

const BBAdminHomeGames = Loadable({
  loader: () => import('./main/views/basketball/admin/season/homegames'),
  loading: Loading,
});

const BBAdminJudges = Loadable({
  loader: () => import('./main/views/basketball/admin/season/judges'),
  loading: Loading,
});

const BBAdminMessages = Loadable({
  loader: () => import('./main/views/basketball/admin/messages'),
  loading: Loading,
});

const BBCoachesConflicts = Loadable({
  loader: () => import('./main/views/basketball/admin/season/coachesconflicts'),
  loading: Loading,
});

const BBCoachPresences = Loadable({
  loader: () => import('./main/views/basketball/user/coachpresences'),
  loading: Loading,
});

const BBDashboard = Loadable({
  loader: () => import('./main/views/basketball/dashboard'),
  loading: Loading,
});

const BBClub = Loadable({
  loader: () => import('./main/views/basketball/admin/general/club'),
  loading: Loading,
});

const BBMembers = Loadable({
  loader: () => import('./main/views/basketball/admin/general/members'),
  loading: Loading,
});

const BBMembersImport = Loadable({
  loader: () => import('./main/views/basketball/admin/general/importwizard'),
  loading: Loading,
});

const BBTeams = Loadable({
  loader: () => import('./main/views/basketball/admin/general/teams'),
  loading: Loading,
});

const BBGyms = Loadable({
  loader: () => import('./main/views/basketball/admin/general/gyms'),
  loading: Loading,
});

const BBGymKeys = Loadable({
  loader: () => import('./main/views/basketball/admin/general/gyms/gymkeys'),
  loading: Loading,
});

const BBGymSpectators = Loadable({
  loader: () => import('./main/views/basketball/admin/general/gyms/spectators'),
  loading: Loading,
});

const BBCars = Loadable({
  loader: () => import('./main/views/basketball/admin/general/cars'),
  loading: Loading,
});

const BBCarReservations = Loadable({
  loader: () =>
    import('./main/views/basketball/admin/general/cars/reservations'),
  loading: Loading,
});

const BBContacts = Loadable({
  loader: () => import('./main/views/basketball/season/contacts'),
  loading: Loading,
});

const BBLeagues = Loadable({
  loader: () => import('./main/views/basketball/admin/season/leagues'),
  loading: Loading,
});

const BBJudges = Loadable({
  loader: () => import('./main/views/basketball/season/judges'),
  loading: Loading,
});

const BBPlayers = Loadable({
  loader: () => import('./main/views/basketball/season/players'),
  loading: Loading,
});

const BBPracticeTimes = Loadable({
  loader: () => import('./main/views/basketball/season/practicetimes'),
  loading: Loading,
});

const BBRefereesSchedule = Loadable({
  loader: () => import('./main/views/basketball/admin/season/referees'),
  loading: Loading,
});

const BBRefereesSwitches = Loadable({
  loader: () => import('./main/views/basketball/referees/switches'),
  loading: Loading,
});

const BBRefereeMySchedule = Loadable({
  loader: () => import('./main/views/basketball/referees/myschedule'),
  loading: Loading,
});

const BBResultReporting = Loadable({
  loader: () => import('./main/views/basketball/admin/season/resultreporting'),
  loading: Loading,
});

const BBSchedule = Loadable({
  loader: () => import('./main/views/basketball/season/schedule'),
  loading: Loading,
});

const BBTeamEvents = Loadable({
  loader: () => import('./main/views/basketball/team/events'),
  loading: Loading,
});

const BBTeamCalendar = Loadable({
  loader: () => import('./main/views/basketball/team/calendar'),
  loading: Loading,
});

const BBTeamFriendlyGames = Loadable({
  loader: () => import('./main/views/basketball/team/admin/friendlygames'),
  loading: Loading,
});

const BBTeamJerseys = Loadable({
  loader: () => import('./main/views/basketball/team/admin/jerseys'),
  loading: Loading,
});

const BBTeamJudges = Loadable({
  loader: () => import('./main/views/basketball/team/admin/judges'),
  loading: Loading,
});

const BBTeamMessages = Loadable({
  loader: () => import('./main/views/basketball/team/messages'),
  loading: Loading,
});

const BBTeamPlayers = Loadable({
  loader: () => import('./main/views/basketball/team/players'),
  loading: Loading,
});

const BBTeamPractices = Loadable({
  loader: () => import('./main/views/basketball/team/admin/practices'),
  loading: Loading,
});

const BBTeamPracticeReporting = Loadable({
  loader: () => import('./main/views/basketball/team/admin/practicereporting'),
  loading: Loading,
});

const BBTeamSettings = Loadable({
  loader: () => import('./main/views/basketball/team/admin/settings'),
  loading: Loading,
});

const BBUserMyMessages = Loadable({
  loader: () => import('./main/views/basketball/user/mymessages'),
  loading: Loading,
});

const BBUserMySchedule = Loadable({
  loader: () => import('./main/views/basketball/user/myschedule'),
  loading: Loading,
});

const BBUserNotifications = Loadable({
  loader: () => import('./main/views/basketball/user/notifications'),
  loading: Loading,
});

const BBUserProfile = Loadable({
  loader: () => import('./main/views/basketball/user/profile'),
  loading: Loading,
});

const BBUserSettings = Loadable({
  loader: () => import('./main/views/basketball/user/settings'),
  loading: Loading,
});

const BBUserSwitchRequests = Loadable({
  loader: () => import('./main/views/basketball/user/switchrequests'),
  loading: Loading,
});

*/

/*
    OTHER ROUTES
 */

/*
const JiraIssues = Loadable({
  loader: () => import('./main/views/basketball/general/issues'),
  loading: Loading,
});
*/

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes: Route[] = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    auth: AuthRoles.bbuser,
    component: Dashboard,
  },
  {
    path: '/season/schedule',
    name: 'schedule',
    auth: AuthRoles.bbuser,
    component: SchedulePage,
  },
  {
    path: '/season/practice-times',
    name: 'practice-times',
    auth: AuthRoles.bbuser,
    component: PracticeTimesPage,
  },
  {
    path: '/statistics',
    name: 'statistics',
    auth: AuthRoles.bbuser,
    component: StatisticsPage,
  },
  /************************************************************************************************************
   *
   *                                              KNOWLEDGE BASE
   *
   *************************************************************************************************************/
  {
    path: '/knowledge-base',
    name: 'knowledge-base',
    auth: AuthRoles.bbuser,
    component: KnowledgeBaseHomePage,
  },
  {
    path: '/knowledge-base/articles/:id',
    name: 'knowledge-base-article',
    auth: AuthRoles.bbuser,
    component: KnowledgeBaseArticlePage,
  },
  {
    path: '/knowledge-base/articles/:id/edit',
    name: 'knowledge-base-article-edit',
    auth: AuthRoles.bbuser,
    component: AddEditKnowledgeBaseArticlePage,
  },
  {
    path: '/knowledge-base/articles/new',
    name: 'knowledge-base-article-new',
    auth: AuthRoles.bbuser,
    component: AddEditKnowledgeBaseArticlePage,
  },
  {
    path: '/knowledge-base/categories/:id',
    name: 'knowledge-base-category',
    auth: AuthRoles.bbuser,
    component: KnowledgeBaseCategoryPage,
  },
  {
    path: '/knowledge-base/search',
    name: 'knowledge-base-category',
    auth: AuthRoles.bbuser,
    component: KnowledgeBaseSearchResultsPage,
  },
  /************************************************************************************************************
   *
   *                                                   USER
   *
   *************************************************************************************************************/
  {
    path: '/user/events',
    name: 'my_events',
    auth: AuthRoles.bbuser,
    component: UserEventsPage,
  },
  {
    path: '/user/messages',
    name: 'my_messages',
    auth: AuthRoles.bbuser,
    component: UserMessagesPage,
  },
  {
    path: '/user/switchrequests',
    name: 'switch_requests',
    auth: AuthRoles.bbuser,
    component: SwitchRequestsPage,
  },
  {
    path: '/user/coachlogging',
    name: 'coach_logging',
    auth: AuthRoles.bbcoach,
    component: CoaachLoggingPage,
  },
  {
    path: '/user/profile',
    name: 'profile',
    auth: AuthRoles.bbuser,
    component: UserProfilePage,
  },
  {
    path: '/user/inventories',
    name: 'profile',
    auth: AuthRoles.bbuser,
    component: UserInventoriesPage,
  },
  {
    path: '/user/tasks',
    name: 'profile',
    auth: AuthRoles.bbuser,
    component: UserTasksPage,
  },
  {
    path: '/user/inventories/:transferId',
    name: 'profile',
    auth: AuthRoles.bbuser,
    component: UserInventoriesPage,
  },
  {
    path: '/user/settings',
    name: 'settings',
    auth: AuthRoles.bbuser,
    component: UserSettingsPage,
  },
  /************************************************************************************************************
   *
   *                                                   TEAM
   *
   *************************************************************************************************************/
  {
    path: '/team/players',
    name: 'players',
    auth: AuthRoles.bbcoach,
    component: TeamPlayersPage,
  },
  {
    path: '/team/events',
    name: 'events',
    auth: AuthRoles.bbcoach,
    component: TeamEventsPage,
  },
  {
    path: '/team/messages',
    name: 'messages',
    auth: AuthRoles.bbcoach,
    component: TeamMessagesPage,
  },
  {
    path: '/team/admin/judges',
    name: 'judges',
    auth: AuthRoles.bbcoach,
    component: TeamJudgesPage,
  },
  {
    path: '/team/admin/jerseys',
    name: 'jerseys',
    auth: AuthRoles.bbcoach,
    component: TeamJerseysPage,
  },
  {
    path: '/team/admin/tasks',
    name: 'tasks',
    auth: AuthRoles.bbcoach,
    component: TeamTasksPage,
  },
  {
    path: '/team/admin/settings',
    name: 'settings',
    auth: AuthRoles.bbcoach,
    component: TeamSettingsPage,
  },
  /************************************************************************************************************
   *
   *                                                   SEASON
   *
   *************************************************************************************************************/
  {
    path: '/season/operations-center',
    name: 'operations-center',
    auth: AuthRoles.bbadmin,
    component: OperationsCenterPage,
  },
  {
    path: '/season/gameday',
    name: 'gameday-planer',
    auth: AuthRoles.bbadmin,
    component: GamedayPlanerPage,
  },
  {
    path: '/season/practices',
    name: 'practices',
    auth: AuthRoles.bbadmin,
    component: PracticesAdminPage,
  },
  {
    path: '/season/events',
    name: 'events',
    auth: AuthRoles.bbadmin,
    component: ClubEventsPage,
  },
  {
    path: '/season/planer',
    name: 'season-planer',
    auth: AuthRoles.bbadmin,
    component: SeasonPlanerPage,
  },
  {
    path: '/season/gym-closures',
    name: 'gym-closures',
    auth: AuthRoles.bbadmin,
    component: GymClosuresPage,
  },
  {
    path: '/season/coaches-conflicts',
    name: 'coaches-conflicts',
    auth: AuthRoles.bbadmin,
    component: CoachConflictsPage,
  },
  /************************************************************************************************************
   *
   *                                                   ADMIN
   *
   *************************************************************************************************************/
  {
    path: '/admin/messages',
    name: 'messages',
    auth: AuthRoles.bbadmin,
    component: AdminMessagesPages,
  },
  {
    path: '/admin/tasks',
    name: 'tasks',
    auth: AuthRoles.bbadmin,
    component: ClubTasksPage,
  },
  {
    path: '/admin/inventory',
    name: 'inventory',
    auth: AuthRoles.bbadmin,
    component: InventoryPage,
  },
  {
    path: '/admin/teams',
    name: 'teams',
    auth: AuthRoles.bbadmin,
    component: TeamsPage,
  },
  {
    path: '/admin/users',
    name: 'users',
    auth: AuthRoles.bbadmin,
    component: UsersPage,
  },
  {
    path: '/admin/users/invitation-links',
    name: 'users',
    auth: AuthRoles.bbadmin,
    component: InvitationLinksPage,
  },
  {
    path: '/admin/gyms',
    name: 'users',
    auth: AuthRoles.bbadmin,
    component: GymsPage,
  },
  {
    path: '/admin/leagues',
    name: 'leagues',
    auth: AuthRoles.bbadmin,
    component: LeaguesPage,
  },
  {
    path: '/admin/cars',
    name: 'cars',
    auth: AuthRoles.bbadmin,
    component: CarsPage,
  },
  {
    path: '/admin/cars/reservations',
    name: 'cars',
    auth: AuthRoles.bbadmin,
    component: CarsReservationsPage,
  },
  {
    path: '/admin/partners',
    name: 'partners',
    auth: AuthRoles.bbadmin,
    component: PartnersPage,
  },
  {
    path: '/admin/club',
    name: 'cars',
    auth: AuthRoles.bbadmin,
    component: ClubPage,
  },
  /************************************************************************************************************
   *
   *                                                   VERSIONS
   *
   *************************************************************************************************************/
  {
    path: '/system/versions',
    name: 'versions',
    auth: AuthRoles.bbuser,
    component: VersionsPage,
  },
  /************************************************************************************************************
   *
   *                                                   PUBLIC
   *
   *************************************************************************************************************/
  {
    path: '/forgotPassword',
    name: 'Passwort vergessen',
    auth: AuthRoles.onlyGuest,
    component: ForgotPasswordPage,
  },
  {
    path: '/resetPassword/:token',
    pathIncludes: '/resetPassword',
    name: 'Passwort setzen',
    auth: AuthRoles.onlyGuest,
    component: ResetPasswordPage,
  },
  {
    path: '/login',
    name: 'Login',
    auth: AuthRoles.onlyGuest,
    component: LoginPage,
  },
  {
    path: '/welcome',
    name: 'Willkommen',
    auth: AuthRoles.onlyGuest,
    component: WelcomePage,
  },
  {
    path: '/register/:token',
    pathIncludes: '/register',
    name: 'Registrierung',
    auth: AuthRoles.onlyGuest,
    component: RegisterPage,
  },

  /*
  {
    path: '/register/:token',
    name: 'Registrierung',
    auth: authRoles.onlyGuest,
    component: Registration,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    auth: authRoles.bbuser,
    component: process.env.REACT_APP_BASKETBALL ? BBDashboard : Dashboard,
  },

  /*
   *  BASKETBALL MODULE
   *

  {
    path: '/basketball/changelog',
    name: 'Changelog',
    auth: authRoles.bbuser,
    component: BBChangelog,
  },
  {
    path: '/basketball/dashboard',
    name: 'Dashboard',
    auth: authRoles.bbuser,
    component: BBDashboard,
  },
  {
    path: '/basketball/issues',
    name: 'Entwicklungs-Backlog',
    auth: authRoles.bbuser,
    component: JiraIssues,
  },
  {
    path: '/basketball/season/schedule',
    name: 'Spielplan',
    auth: authRoles.bbuser,
    component: BBSchedule,
  },
  {
    path: '/basketball/season/archive',
    name: 'Archiv',
    auth: authRoles.bbuser,
    component: BBArchive,
  },
  {
    path: '/basketball/season/practicetimes',
    name: 'Trainingszeiten',
    auth: authRoles.bbuser,
    component: BBPracticeTimes,
  },
  {
    path: '/basketball/season/judges',
    name: 'Kampfgericht',
    auth: authRoles.bbuser,
    component: BBJudges,
  },
  {
    path: '/basketball/season/players',
    name: 'Spielerliste',
    auth: authRoles.bbadmin,
    component: BBPlayers,
  },
  {
    path: '/basketball/season/contacts',
    name: 'Kontakte',
    auth: authRoles.bbcoachref,
    component: BBContacts,
  },

  {
    path: '/basketball/team/players',
    name: 'Spieler',
    auth: authRoles.bbcoach,
    component: BBTeamPlayers,
  },
  {
    path: '/basketball/team/events',
    name: 'Termine',
    auth: authRoles.bbcoach,
    component: BBTeamEvents,
  },
  {
    path: '/basketball/team/calendar',
    name: 'Terminkalender',
    auth: authRoles.bbcoach,
    component: BBTeamCalendar,
  },
  {
    path: '/basketball/team/messages',
    name: 'Mannschaftsmitteilungen',
    auth: authRoles.bbcoach,
    component: BBTeamMessages,
  },
  {
    path: '/basketball/team/admin/judges',
    name: 'Kampfgericht zuteilen',
    auth: authRoles.bbcoach,
    component: BBTeamJudges,
  },
  {
    path: '/basketball/team/admin/jerseys',
    name: 'Trikotwaschplan',
    auth: authRoles.bbcoach,
    component: BBTeamJerseys,
  },
  {
    path: '/basketball/team/admin/friendlygames',
    name: 'Freundschaftsspiele',
    auth: authRoles.bbcoach,
    component: BBTeamFriendlyGames,
  },
  {
    path: '/basketball/team/admin/practices',
    name: 'Trainingseinheiten',
    auth: authRoles.bbcoach,
    component: BBTeamPractices,
  },
  {
    path: '/basketball/team/admin/practicereporting',
    name: 'Trainingsauswertungen',
    auth: authRoles.bbcoach,
    component: BBTeamPracticeReporting,
  },
  {
    path: '/basketball/team/admin/settings',
    name: 'Mannschaftseinstellungen',
    auth: authRoles.bbcoach,
    component: BBTeamSettings,
  },

  {
    path: '/basketball/referees/myschedule',
    name: 'Meine Schiedsrichtereinsätze',
    auth: authRoles.bbreferee,
    component: BBRefereeMySchedule,
  },
  {
    path: '/basketball/referees/switches',
    name: 'Schiedsrichter Tauschanfragen',
    auth: authRoles.bbreferee,
    component: BBRefereesSwitches,
  },

  {
    path: '/basketball/admin/messages',
    name: 'Mitteilungen',
    auth: authRoles.bbadmin,
    component: BBAdminMessages,
  },

  {
    path: '/basketball/admin/general/club',
    name: 'Verein',
    auth: authRoles.bbadmin,
    component: BBClub,
  },
  {
    path: '/basketball/admin/general/members',
    name: 'Mitgliederliste',
    auth: authRoles.bbadmin,
    component: BBMembers,
  },
  {
    path: '/basketball/admin/general/importwizard',
    name: 'Nutzer CSV Import',
    auth: authRoles.bbadmin,
    component: BBMembersImport,
  },
  {
    path: '/basketball/admin/general/gyms',
    name: 'Sporthallen',
    auth: authRoles.bbadmin,
    component: BBGyms,
    exact: true,
  },
  {
    path: '/basketball/admin/general/gymspectators/:id',
    name: 'Zuschauerauswertung',
    auth: authRoles.bbadmin,
    component: BBGymSpectators,
  },
  {
    path: '/basketball/admin/general/gyms/:id/keys',
    name: 'Schlüsselverwaltung',
    auth: authRoles.bbadmin,
    component: BBGymKeys,
  },
  {
    path: '/basketball/admin/general/cars',
    name: 'Fahrzeuge',
    auth: authRoles.bbadmin,
    component: BBCars,
    exact: true,
  },
  {
    path: '/basketball/admin/general/cars/reservations',
    name: 'Fahrzeugreservierungen',
    auth: authRoles.bbadmin,
    component: BBCarReservations,
  },
  {
    path: '/basketball/admin/season/leagues',
    name: 'Ligen',
    auth: authRoles.bbadmin,
    component: BBLeagues,
  },
  {
    path: '/basketball/admin/season/homegames',
    name: 'Heimspiele',
    auth: authRoles.bbadmin,
    component: BBAdminHomeGames,
  },
  {
    path: '/basketball/admin/season/judges',
    name: 'Kampfgericht',
    auth: authRoles.bbadmin,
    component: BBAdminJudges,
  },
  {
    path: '/basketball/admin/season/referees',
    name: 'Schiedsrichterplan',
    auth: authRoles.bbadmin,
    component: BBRefereesSchedule,
  },
  {
    path: '/basketball/admin/season/awaygames',
    name: 'Auswärtsfahrten',
    auth: authRoles.bbadmin,
    component: BBAdminAwayGames,
  },
  {
    path: '/basketball/admin/season/coachesconflicts',
    name: 'Trainerkonflikte',
    auth: authRoles.bbadmin,
    component: BBCoachesConflicts,
  },
  {
    path: '/basketball/admin/season/resultreporting',
    name: 'Ergebnismeldung',
    auth: authRoles.bbadmin,
    component: BBResultReporting,
  },

  {
    path: '/basketball/user/messages',
    name: 'Nachrichten',
    auth: authRoles.bbuser,
    component: BBUserMyMessages,
  },
  {
    path: '/basketball/user/coachpresences',
    name: 'Trainer Anwesenheiten',
    auth: authRoles.bbcoach,
    component: BBCoachPresences,
  },
  {
    path: '/basketball/user/profile',
    name: 'Profil',
    auth: authRoles.bbuser,
    component: BBUserProfile,
  },
  {
    path: '/basketball/user/settings',
    name: 'Einstellungen',
    auth: authRoles.bbuser,
    component: BBUserSettings,
  },
  {
    path: '/basketball/user/schedule',
    name: 'Meine Termine',
    auth: authRoles.bbuser,
    component: BBUserMySchedule,
  },
  {
    path: '/basketball/user/switchrequests',
    name: 'Wechsel-Anfragen',
    auth: authRoles.bbuser,
    component: BBUserSwitchRequests,
  },
  {
    path: '/basketball/user/notifications',
    name: 'Benachrichtigungen',
    auth: authRoles.bbuser,
    component: BBUserNotifications,
  },
  */
];

export default routes;
